// extracted by mini-css-extract-plugin
module.exports = {"additionalTextLink":"CardsCategoryButton_additionalTextLink__KuDU1"};